var _rect, _path, _rect2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "smartphone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.308,
    height: 24,
    viewBox: "0 0 16.308 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1567",
    "data-name": "Rectangle 1567",
    width: 14.7,
    height: 22.629,
    transform: "translate(0.857 0.857)",
    fill: "#707070"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    d: "M14.571,0H1.714A1.718,1.718,0,0,0,0,1.714H0V22.286A1.718,1.718,0,0,0,1.714,24H14.571a1.62,1.62,0,0,0,1.714-1.714h0V1.714A1.615,1.615,0,0,0,14.571,0ZM5.486,1.029H10.8v.686H5.486Zm9.943,21.257a.737.737,0,0,1-.686.686H1.714a.737.737,0,0,1-.686-.686V1.714a.737.737,0,0,1,.686-.686H4.457v1.2a.455.455,0,0,0,.514.514h6.343a.455.455,0,0,0,.514-.514v-1.2h2.743a.784.784,0,0,1,.857.686h0Z",
    fill: "#707070"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1568",
    "data-name": "Rectangle 1568",
    width: 5.314,
    height: 0.686,
    rx: 0.343,
    transform: "translate(5.486 1.029)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_174",
    "data-name": "Ellipse 174",
    cx: 1.886,
    cy: 1.886,
    r: 1.886,
    transform: "translate(6.343 18.686)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.35a0b654ce523f621a4ddfdeb58d0943.svg";
export { ForwardRef as ReactComponent };